import {ActionIcon, Button, Divider, Grid, Group, Radio} from "@mantine/core";
import {useCallback} from "react";
import {useTranslation} from "react-i18next";
import {useForm} from "@mantine/form";
import {DateInput} from "../../date/DateInput/DateInput";
import {isBefore} from "@ots-frontend/ots-data"
import {IconFilter} from "@tabler/icons-react";
import {
  DriverActivityFilterFormValues,
  isDefaultDriverActivityFilter
} from "../../form/DriverActivityFilterForm/DriverActivityFilterForm";

type DriverActivityToolbarProps = {
  defaultValues?: {
    by?: "shift" | "transport"
    fromDate?: Date
    toDate?: Date
  }
  onSubmit?: (by: "shift" | "transport", fromDate: Date | undefined, toDate: Date | undefined) => void
  filter?: DriverActivityFilterFormValues,
  onFilterClick?: () => void
  loading?: boolean
}

export const DriverActivityToolbar = (props: DriverActivityToolbarProps) => {
  const {
    defaultValues,
    onSubmit,
    loading,
    filter,
    onFilterClick,
  } = props;

  const {t} = useTranslation(["common"]);

  const form = useForm({
    initialValues: {
      by: defaultValues?.by,
      fromDate: defaultValues?.fromDate,
      toDate: defaultValues?.toDate,
    },
    validate: {
      toDate: (value, values) => {
        let error: string | undefined = undefined
        if (value && values.fromDate && isBefore(value, values.fromDate)) {
          error = t<string>("common.form.validation.todatebeforefrom", "The to date can't be before the from date")
        }
        return error
      }
    }
  });

  const onFormSubmit = useCallback(async (values: typeof form.values) => {
    if (onSubmit) {
      onSubmit(values.by ?? "shift", values.fromDate, values.toDate)
    }
  }, [form, onSubmit])

  return (
    <Grid p="xs">
      <Grid.Col span={2}>
        <Group position="left" align="center">
          <ActionIcon
            variant={!isDefaultDriverActivityFilter(filter) ? "filled" : "subtle"}
            color={!isDefaultDriverActivityFilter(filter) ? "service-work" : undefined}
            onClick={onFilterClick}>
            <IconFilter size="1.125rem"/>
          </ActionIcon>
        </Group>
      </Grid.Col>
      <Grid.Col span={6}>
        <form onSubmit={form.onSubmit(onFormSubmit)}>
          <Group position="center" align="flex-end">
            <Radio.Group
              label={t("common.ui.toolbar.fromtodate.form.field.by", "By")}
              {...form.getInputProps("by")} >

              <Group mt="xs">
                <Radio value="shift" label="Shift"/>
                <Radio value="transport" label="Transport"/>
              </Group>

            </Radio.Group>
            <Divider orientation="vertical"/>
            <DateInput
              valueFormat="MM/DD/YYYY HH:mm"
              label={t("common.ui.toolbar.fromtodate.form.field.fromdate", "From Date")}
              placeholder={t<string>("common.ui.toolbar.fromtodate.form.field.fromdate", "From Date")}
              clearable
              popoverProps={{
                withinPortal: true
              }}
              styles={{wrapper: {width: "200px"}}}
              {...form.getInputProps("fromDate")} />
            <DateInput
              miw={100}
              valueFormat="MM/DD/YYYY HH:mm"
              label={t("common.ui.toolbar.fromtodate.form.field.todate", "To Date")}
              placeholder={t<string>("common.ui.toolbar.fromtodate.form.field.todate", "To Date")}
              clearable
              popoverProps={{
                withinPortal: true
              }}
              styles={{wrapper: {width: "200px"}}}
              {...form.getInputProps("toDate")} />
            <Button type="submit" loading={loading} variant="outline">
              {t("common.action.submit", {ns: "common"})}
            </Button>
          </Group>
        </form>
      </Grid.Col>
      <Grid.Col span={2}>
      </Grid.Col>
    </Grid>
  );
};
